var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.5,
    height: 21.5,
    viewBox: "0 0 21.5 21.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.28,5.374A10.657,10.657,0,0,0,1.512,18.231L0,23.75l5.649-1.483a10.622,10.622,0,0,0,5.092,1.3h0A10.757,10.757,0,0,0,21.5,12.909a10.7,10.7,0,0,0-3.22-7.535ZM10.745,21.768a8.84,8.84,0,0,1-4.511-1.233l-.322-.192-3.35.878.893-3.268-.211-.336A8.872,8.872,0,1,1,19.7,12.909a8.954,8.954,0,0,1-8.955,8.859ZM15.6,15.136c-.264-.134-1.574-.777-1.819-.864s-.422-.134-.6.134-.686.864-.845,1.046-.312.2-.576.067a7.246,7.246,0,0,1-3.623-3.167c-.274-.47.274-.437.782-1.454a.493.493,0,0,0-.024-.466c-.067-.134-.6-1.445-.821-1.977S7.64,8.009,7.477,8s-.331-.01-.509-.01a.986.986,0,0,0-.71.331,2.991,2.991,0,0,0-.931,2.222A5.215,5.215,0,0,0,6.412,13.3a11.9,11.9,0,0,0,4.55,4.022,5.209,5.209,0,0,0,3.2.667,2.727,2.727,0,0,0,1.795-1.267,2.226,2.226,0,0,0,.154-1.267C16.043,15.332,15.866,15.265,15.6,15.136Z",
    transform: "translate(0 -2.25)",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.76cef6a0cb37840440d0b565143e6cf2.svg";
export { ForwardRef as ReactComponent };